import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Preloader({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const duration = 2000;
    const tick = (t) => {
      const p = Math.min(100, Math.round(((t - start) / duration) * 100));
      setProgress(p);
      if (p < 100) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(() => {
          setDone(true);
          onDone?.();
        }, 400);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[100] bg-obsidian text-bone flex flex-col items-center justify-center"
          exit={{ y: '-100%' }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          data-testid="preloader"
        >
          <div className="overflow-hidden">
            <motion.div
              initial={{ y: '110%' }}
              animate={{ y: 0 }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
              className="serif italic text-5xl md:text-7xl tracking-tighter"
            >
              RaufMedia
            </motion.div>
          </div>
          <div className="mt-8 w-[220px] md:w-[320px] h-px bg-bone/20 relative overflow-hidden">
            <motion.div
              className="absolute left-0 top-0 h-full bg-signal"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="mt-4 font-sans text-xs tracking-[0.3em] uppercase text-bone/60">
            {progress}% — Loading experience
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
